import type { ConcreteAccount } from '@thinkalpha/trading-ws-client/contracts/account.js';

export const generateAccountNameToDisplay = (account: ConcreteAccount) => {
    if (account.displayName && account.displayName.length > 0 && account.displayName !== account.name) {
        return `${account.displayName} (${account.name})`;
    }
    return account.name;
};
